(() => {
  const dialog = document.querySelector('[data-age-gate]');
  if (!dialog) return;
  const editor = dialog.dataset.editor === 'true';
  if (editor && dialog.dataset.preview !== 'true') return;
  const key = 'happy-vibes-age-confirmation';
  const age = Number(dialog.dataset.age);
  const days = Number(dialog.dataset.days);
  function confirmed() {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return value?.age === age && Number.isFinite(value.expires) && value.expires > Date.now();
    } catch { return false; }
  }
  function open() {
    if (!editor && confirmed()) return;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('age-gate-open');
  }
  dialog.addEventListener('cancel', (event) => event.preventDefault());
  dialog.addEventListener('close', () => document.documentElement.classList.remove('age-gate-open'));
  dialog.querySelector('[data-age-accept]').addEventListener('click', () => {
    if (!editor) {
      try { localStorage.setItem(key, JSON.stringify({ age, expires: Date.now() + days * 86400000 })); } catch { /* Confirmation still works when storage is blocked. */ }
    }
    dialog.close();
  });
  dialog.querySelector('[data-age-decline]').addEventListener('click', (event) => {
    event.preventDefault();
    if (editor) { dialog.close(); return; }
    window.location.replace(event.currentTarget.href);
  });
  window.addEventListener('pageshow', open);
  open();
})();
